
import { defineComponent } from "vue-demi";

export default defineComponent({
  name: "VUploadDocuments",

  components: {
    UploadDocuments: () => import("@/modules/Documents/UploadDocuments.vue"),
  },
});
